export const iconFontAwesomeMapsTicketSimple = (
	<i className="fa-solid fa-ticket-simple"></i>
);
